<template>
  <div class="vip-order-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索订单号/用户ID" class="search" clearable @keyup.enter="loadList" />
      <el-select v-model="statusFilter" placeholder="订单状态" clearable style="width:150px" @change="loadList">
        <el-option label="待支付" :value="0" />
        <el-option label="开通中" :value="1" />
        <el-option label="已取消" :value="2" />
        <el-option label="已完成" :value="3" />
        <el-option label="已折抵" :value="4" />
      </el-select>
      <el-button type="primary" @click="loadList">搜索</el-button>
    </div>
    <el-table :data="list" stripe style="width:100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="trade_no" label="订单号" width="200" />
      <el-table-column prop="user_id" label="用户ID" width="100" />
      <el-table-column label="套餐" width="120">
        <template #default="{row}">
          <span v-if="row.plan">{{ row.plan.name }}</span>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="80">
        <template #default="{row}">
          <el-tag v-if="row.type === 1" type="success">新购</el-tag>
          <el-tag v-else-if="row.type === 2" type="warning">续费</el-tag>
          <el-tag v-else-if="row.type === 3" type="info">升级</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="period" label="周期" width="100" />
      <el-table-column label="金额" width="150">
        <template #default="{row}">
          <div>
            <div>总额：{{ (row.total_amount / 100).toFixed(2) }}元</div>
            <div v-if="row.balance_amount" class="sub-amount">余额：{{ (row.balance_amount / 100).toFixed(2) }}元</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="{row}">
          <el-tag v-if="row.status === 0" type="warning">待支付</el-tag>
          <el-tag v-else-if="row.status === 1" type="info">开通中</el-tag>
          <el-tag v-else-if="row.status === 2" type="danger">已取消</el-tag>
          <el-tag v-else-if="row.status === 3" type="success">已完成</el-tag>
          <el-tag v-else-if="row.status === 4" type="info">已折抵</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180">
        <template #default="{row}">
          {{ formatTime(row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template #default="{row}">
          <el-button size="small" @click="viewDetail(row)">详情</el-button>
          <el-button v-if="row.status === 0" size="small" type="danger" @click="cancelOrder(row)">取消</el-button>
          <el-divider direction="vertical" />
          <el-dropdown>
            <el-button size="small">
              手动更新状态
              <el-icon class="el-icon--right"><i class="el-icon-arrow-down" /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="updateStatus(row, 1)">设为开通中</el-dropdown-item>
                <el-dropdown-item @click="updateStatus(row, 2)">设为已取消</el-dropdown-item>
                <el-dropdown-item @click="updateStatus(row, 3)">设为已完成</el-dropdown-item>
                <el-dropdown-item @click="updateStatus(row, 4)">设为已折抵</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next, total"
      @current-change="pageChange"
    />

    <el-dialog v-model="detailVisible" title="订单详情" width="700px">
      <el-descriptions :column="2" border v-if="detailData">
        <el-descriptions-item label="订单ID">{{ detailData.id }}</el-descriptions-item>
        <el-descriptions-item label="订单号">{{ detailData.trade_no }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detailData.user_id }}</el-descriptions-item>
        <el-descriptions-item label="套餐ID">{{ detailData.plan_id }}</el-descriptions-item>
        <el-descriptions-item label="订单类型">
          <el-tag v-if="detailData.type === 1" type="success">新购</el-tag>
          <el-tag v-else-if="detailData.type === 2" type="warning">续费</el-tag>
          <el-tag v-else-if="detailData.type === 3" type="info">升级</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="周期">{{ detailData.period }}</el-descriptions-item>
        <el-descriptions-item label="订单金额">{{ (detailData.total_amount / 100).toFixed(2) }}元</el-descriptions-item>
        <el-descriptions-item label="使用余额">{{ detailData.balance_amount ? ((detailData.balance_amount / 100).toFixed(2) + '元') : '—' }}</el-descriptions-item>
        <el-descriptions-item label="手续费">{{ detailData.handling_amount ? ((detailData.handling_amount / 100).toFixed(2) + '元') : '—' }}</el-descriptions-item>
        <el-descriptions-item label="优惠金额">{{ detailData.discount_amount ? ((detailData.discount_amount / 100).toFixed(2) + '元') : '—' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag v-if="detailData.status === 0" type="warning">待支付</el-tag>
          <el-tag v-else-if="detailData.status === 1" type="info">开通中</el-tag>
          <el-tag v-else-if="detailData.status === 2" type="danger">已取消</el-tag>
          <el-tag v-else-if="detailData.status === 3" type="success">已完成</el-tag>
          <el-tag v-else-if="detailData.status === 4" type="info">已折抵</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">{{ detailData.paid_at ? formatTime(detailData.paid_at) : '—' }}</el-descriptions-item>
        <el-descriptions-item label="第三方订单号">{{ detailData.callback_no || '—' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detailData.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatTime(detailData.updated_at) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'
import store from '../../store'

const list = ref([])
const pagination = ref({ page: 1, pageSize: 20, total: 0 })
const keyword = ref('')
const statusFilter = ref(null)
const detailVisible = ref(false)
const detailData = ref(null)

const formatTime = (timestamp) => {
  if (!timestamp) return '—'
  const date = new Date(timestamp * 1000)
  return date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

const loadList = async () => {
  const params = {
    page: pagination.value.page,
    pageSize: pagination.value.pageSize
  }
  if (keyword.value) {
    params.keyword = keyword.value
  }
  if (statusFilter.value !== null && statusFilter.value !== '') {
    params.status = statusFilter.value
  }
  try {
    const data = await request.get('/v1/admin/vip-order/list', { params })
    const raw = data.list || []
    list.value = raw.map(it => ({
      ...it,
      type: Number(it.type),
      status: Number(it.status)
    }))
    pagination.value.total = data.pagination?.total || 0
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const pageChange = (p) => {
  pagination.value.page = p
  loadList()
}

const viewDetail = async (row) => {
  try {
    const data = await request.get('/v1/admin/vip-order/view', { params: { order_id: row.id } })
    detailData.value = {
      ...data,
      type: Number(data.type),
      status: Number(data.status)
    }
    detailVisible.value = true
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const cancelOrder = async (row) => {
  try {
    await ElMessageBox.confirm('确定要取消这个订单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await request.post('/v1/admin/vip-order/cancel', { order_id: row.id })
    ElMessage.success('订单已取消')
    loadList()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error(e.toString())
    }
  }
}

const updateStatus = async (row, status) => {
  const label =
    status === 1 ? '开通中' :
    status === 2 ? '已取消' :
    status === 3 ? '已完成（将按订单开通会员）' :
    status === 4 ? '已折抵' : status
  try {
    await ElMessageBox.confirm(`确定将订单 [${row.trade_no}] 状态设为「${label}」吗？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await request.post('/v1/admin/vip-order/update-status', { order_id: row.id, status })
    ElMessage.success('状态已更新')
    loadList()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error(e.toString())
    }
  }
}

onMounted(() => {
  if (store.state.token) {
    loadList()
  }
})
</script>

<style scoped>
.vip-order-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.search {
  width: 200px;
}
.sub-amount {
  font-size: 12px;
  color: #909399;
}
.pager {
  margin-top: 15px;
  text-align: right;
}
</style>
